import React from 'react';

/**
 * Renders a menu item in the top navbar
 */
export default class MainMenuItem extends React.Component {

    renderMenuComponent() {
        return (
            <div />
        );
    }

    render() {
        return (
            <div className={'main-menu-item'}>
                {this.renderMenuComponent()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/header/MainMenuItem.js